import { z } from 'zod';

const browserEnvironmentSchema = z.object({
  VITE_SUPABASE_URL: z.url(),
  VITE_SUPABASE_PUBLISHABLE_KEY: z.string().min(20),
  VITE_TURNSTILE_SITE_KEY: z.string().min(3).optional()
});

export function readBrowserEnvironment(environment: Record<string, unknown>) {
  const result = browserEnvironmentSchema.safeParse(environment);
  if (!result.success) {
    const missing = result.error.issues.map((issue) => issue.path.join('.')).join(', ');
    throw new Error(`Invalid browser environment configuration: ${missing}`);
  }
  return result.data;
}
